import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const ChevronLeft = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 12 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.35355 2.64645C7.54882 2.84171 7.54882 3.15829 7.35355 3.35355L4.70711 6L7.35355 8.64645C7.54882 8.84171 7.54882 9.15829 7.35355 9.35355C7.15829 9.54882 6.84171 9.54882 6.64645 9.35355L3.64645 6.35355C3.45118 6.15829 3.45118 5.84171 3.64645 5.64645L6.64645 2.64645C6.84171 2.45118 7.15829 2.45118 7.35355 2.64645Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default ChevronLeft
